import { DataSupplierFilter, GetArticlesByWholesalerArticleNosResponse, GetProductGroupAndSupplierFiltersResponse } from "@bundles/parts/data/model"

export function isExtendedAssortmentForced(
    loadedFilters: GetProductGroupAndSupplierFiltersResponse | GetArticlesByWholesalerArticleNosResponse | undefined,
    selectedProductGroupIds: number[],
    selectedDataSupplierIds: number[],
    isSuccess: boolean,
    dataSupplierFilterPriorityPropertySelector: (dataSupplierFilter: DataSupplierFilter) => boolean | undefined
) {
    const noResult = isSuccess && !loadedFilters?.productGroupFilters.length && !loadedFilters?.dataSupplierFilters.length
    if (noResult) {
        return true
    }

    const anyExtendedProductGroupsIsSelected = loadedFilters?.productGroupFilters.some(
        (x) => !x.hasTopPrioritySuppliers && selectedProductGroupIds.includes(x.id)
    )
    if (anyExtendedProductGroupsIsSelected) {
        return true
    }

    const anyExtendedSupplierIsSelected = loadedFilters?.dataSupplierFilters.some(
        (x) => !dataSupplierFilterPriorityPropertySelector(x) && selectedDataSupplierIds.includes(x.id)
    )
    if (anyExtendedSupplierIsSelected) {
        return true
    }

    const noPriorityProductGroupFilter =
        isSuccess && !!loadedFilters?.productGroupFilters.length && loadedFilters.productGroupFilters.every((x) => !x.hasTopPrioritySuppliers)
    if (noPriorityProductGroupFilter) {
        return true
    }

    const noPrioritySupplierFilter =
        isSuccess && !!loadedFilters?.dataSupplierFilters.length && loadedFilters.dataSupplierFilters.every((x) => !x.showOnTop)
    if (noPrioritySupplierFilter) {
        return true
    }

    return false
}
